// extracted by mini-css-extract-plugin
module.exports = {"base":"UserBadges_base__sMY_B","icon_20":"UserBadges_icon_20__2dVRA","icon_40":"UserBadges_icon_40__2E0W5","icon_60":"UserBadges_icon_60__23rJG"};